// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#285cdb","colorSecondary":"#414d55","bodyBg":"#f1f5f8"};